import smbPrimeLogoColored from '../../assets/Logo/Final/Horizontal_Colored.png';
import smbPrimeLogoWhite from '../../assets/Logo/Final/Horizontal_White.png';

interface BrandLogoProps {
  className?: string;
  alt?: string;
  /** Use "white" on dark backgrounds for contrast; use "colored" for the blue gradient logo. */
  variant?: 'white' | 'colored';
}

export const BrandLogo = ({
  className = 'h-8 w-auto',
  alt = 'SMBPrime',
  variant = 'colored',
}: BrandLogoProps): JSX.Element => {
  const src = variant === 'colored' ? smbPrimeLogoColored : smbPrimeLogoWhite;
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};
